import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        canManageCourse: '<',
        trainingForm: '=',
        key: '<',
        isDisabled: '<',
        ckconfig: '<',
        trainingTypes: '<'
    },
    template: `
<form-row error="vm.form.errors.courseTrainings[vm.key].file">
    <label class="label">{{ 'courses.Training image' | translate}}</label>
    <div class="items w100p">
        <input ng-disabled="!vm.canManageCourse"
            ngf-select="vm.CourseVersionTrainingFormFileService.setImage($file, vm.trainingForm)" ng-model="vm.trainingForm.file" type="file" />
        <form-row-error></form-row-error>
    </div>
</form-row>

<form-row ng-if="vm.trainingForm.imageFilename">
    <div class="items w100p">
        <div class="form-img">
            <img ng-src="{{ vm.CourseVersionService.getTrainingImageUrl(vm.trainingForm, vm.form.model.companyId, 'small') }}">
            <ul class="actions01">
                <li><a class="btn delete" ng-click="vm.CourseVersionTrainingFormFileService.deleteImage(vm.trainingForm)">
                    {{ 'general.Remove' | translate }}
                </a></li>
            </ul>
        </div>
    </div>
</form-row>

<form-row error="vm.form.errors.courseTrainings[vm.key].passingType">
    <span class="label">
        {{ 'training.Required for completion' | translate }} *
        <tooltip html="vm.tooltipTexts.passingType" />
    </span>
    <div class="items w100p">
        <ul class="checkboxes">
            <li>
                <label
                    ng-disabled="vm.isDisabled || vm.trainingForm.type === vm.COURSE_TRAINING_TYPE_ENUM.KEYS.FEEDBACK"
                    ng-repeat="value in vm.COURSE_TRAINING_PASSING_TYPE_ENUM.KEYS">
                    <input
                        ng-disabled="vm.isDisabled || vm.trainingForm.type === vm.COURSE_TRAINING_TYPE_ENUM.KEYS.FEEDBACK"
                        name="r02" type="radio" ng-model="vm.trainingForm.passingType" ng-value="'{{ value }}'">
                    {{ vm.COURSE_TRAINING_PASSING_TYPE_ENUM.LABELS[value] }}
                </label>
            </li>
        </ul>
    </div>
</form-row>

<div class="row row-wide" error="vm.form.errors.courseTrainings[vm.key].courseTrainingI18ns[vm.defaultLanguage].description">
    <label class="label">
        {{ 'courses.Description' | translate }}
        <tooltip html="vm.tooltipTexts.description" />
    </label>
    <div class="items w100p">
        <ng-ckeditor ng-model="vm.trainingForm.courseTrainingI18ns[vm.defaultLanguage].description" class="mt10" ng-config="vm.ckconfig"></ng-ckeditor>
    </div>
</div>

<form-row error="vm.form.errors.courseTrainings[vm.key].duration">
    <label class="label">{{ 'training.Expected duration (h)' | translate }}</label>
    <div class="items">
        <input ng-disabled="!vm.canManageCourse" type="text" ng-model="vm.trainingForm.duration" class="form-control">
        <form-row-error></form-row-error>
    </div>
</form-row>
    `
})

export default class {
    constructor (TokenService, CourseVersionService, CourseVersionTrainingFormFileService,
                COURSE_TRAINING_PASSING_TYPE_ENUM, COURSE_TRAINING_TYPE_ENUM, ModalService, $translate) {
        this.TokenService = TokenService;
        this.CourseVersionService = CourseVersionService;
        this.CourseVersionTrainingFormFileService = CourseVersionTrainingFormFileService;
        this.COURSE_TRAINING_PASSING_TYPE_ENUM = COURSE_TRAINING_PASSING_TYPE_ENUM;
        this.COURSE_TRAINING_TYPE_ENUM = COURSE_TRAINING_TYPE_ENUM;
        this.ModalService = ModalService;
        this.$translate = $translate;
        this.defaultLanguage = TokenService.getCompanyLanguage();
        this.loading = false;

        if (this.trainingForm.type === COURSE_TRAINING_TYPE_ENUM.KEYS.FEEDBACK) {
            this.trainingForm.passingType = COURSE_TRAINING_PASSING_TYPE_ENUM.KEYS.OPTIONAL;
        }
    }

    $onInit () {
        this.tooltipTexts = {
            passingType: this.$translate.instant('training.Required for completion tooltip'),
            description: this.$translate.instant('courses.Training description tooltip')
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/steps/version/training/additional/index.js